import { createElement, type ComponentProps } from 'react';
import { useCapability } from '../hooks/useCapability';
import { Button } from './ui/button';
import { AlertDialogAction } from './ui/alert-dialog';

type Props = ComponentProps<typeof Button> & {
  capability: string;
  component?: typeof AlertDialogAction;
};

/** Keep unavailable actions visible but disabled; API policies remain authoritative. */
export function CapabilityButton({ capability, component, disabled, ...props }: Props) {
  const allows = useCapability();
  return createElement(component ?? Button, { ...props, disabled: disabled || !allows(capability) });
}
